import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../../../store/slices/pageSlice";
import {
  setApprovedOpProjectsState,
  setAssignedOpProjectsState,
  setCompleteOpProjectsState,
  setFilterRequestProjectsState,
  setOngoingOpProjectsState,
  setSelectedTabState,
  setSelectedTabProjectRequest,
  setSelectedTabProjectApproved,
  setSelectedTabProjectAssign,
  setSelectedTabProjectOngoing,
  setSelectedTabProjectComplete,
} from "../../../store/slices/OperationSlices/operationStateSlice";
import OpProjects from "./OpParent/OpProjects";
import ProjectRequestedOP from "./ProjectRequestedOP/ProjectRequestedOP";
import ProjectAssignOPdash from "./ProjectAssignOP/ProjectAssignOPdash";
import ProjectOngoingOPDash from "./ProjectOngoingOP/ProjectOngoingOPDash";
import ProjectCompletedOpDash from "./ProjectCompletedOP/ProjectCompletedOpDash";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import ProjectApprovedDash from "./ProjectApprovedOP/ProjectApprovedDash";
import { fetchWorkEntriesProjectTracking } from "../../../store/slices/workentriesSlice";
import { fetchEmployees } from "../../../store/slices/employeeAdminSlice";
import MyTraining from "../../MyTraining/MyTraining";
import { fetchHardwareProjectTracking } from "../../../store/slices/hardwareDescriptionSlice";
import TimeEntriesGraph from "../OperationFeatures/TimeEntriesGraph";
import SpeedometerGraph from "../OperationFeatures/SpeedometerGraph";
import TaskInHand from "../OperationFeatures/TaskInHand";
import UtilizationReport from "../OperationFeatures/UtilizationReport";
import ManagerMyProjects from "../Projectmanager/ManagerMyProjects";
import ProjectManager from "../OperationParent/ProjectManager";
import {
  setOngoingHardwareParts,
  setOngoingProjectsRedux,
  setOngoingWorkentries,
} from "../../../store/slices/ProjectOngoing/operationFeatureSlice";
import { hasViewOrFullAccess, getFeatureAccessLevel } from "../../../utils/featureAccessUtils";

const MyRequests = () => {
  const dispatch = useDispatch();
  const { projects } = useSelector((state) => state.projects);
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );

  useEffect(() => {
    dispatch(setCurrentPageTitle("Operations Persons Dashboard"));
    dispatch(fetchAllProjects());
    dispatch(fetchHardwareProjectTracking());
  }, [dispatch]);

  // Reset My Request tab selection on mount so no tab (e.g. Project Ongoing) is open by default – user can click any tab
  useEffect(() => {
    dispatch(setSelectedTabState(""));
    dispatch(setSelectedTabProjectRequest(false));
    dispatch(setSelectedTabProjectApproved(false));
    dispatch(setSelectedTabProjectAssign(false));
    dispatch(setSelectedTabProjectOngoing(false));
    dispatch(setSelectedTabProjectComplete(false));
  }, [dispatch]);

  const [ongoingEntries, setongoingEntries] = useState([]);
  const [ongoingHardwareParts, setongoingHardwareParts] = useState([]);

  const selectedTabState = useSelector(
    (state) => state.operationState.selectedTabState
  );

  const selectedTabprojectrequest = useSelector(
    (state) => state.operationState.selectedTabprojectrequest
  );
  const selectedTabprojectapproved = useSelector(
    (state) => state.operationState.selectedTabprojectapproved
  ); const selectedTabprojectassign = useSelector(
    (state) => state.operationState.selectedTabprojectassign
  ); const selectedTabprojectongoing = useSelector(
    (state) => state.operationState.selectedTabprojectongoing
  );   const selectedTabprojectcomplete = useSelector(
    (state) => state.operationState.selectedTabprojectcomplete
  );

  const filterRequestProjectsState = useSelector(
    (state) => state.operationState.filterRequestProjectsState
  );
  const approvedOpProjectsState = useSelector(
    (state) => state.operationState.approvedOpProjectsState
  );
  const assignedOpProjectsState = useSelector(
    (state) => state.operationState.assignedOpProjectsState
  );
  const ongoingOpProjectsState = useSelector(
    (state) => state.operationState.ongoingOpProjectsState
  );
  const completeOpProjectsState = useSelector(
    (state) => state.operationState.completeOpProjectsState
  );

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { employees } = useSelector((state) => state.employees);
  const [currentEmployee, setcurrentEmployee] = useState();
  const email = localStorage.getItem("email")

  console.log("currentEmployee", window.innerWidth)

  useEffect(() => {
    const employee = employees.find((emp) => emp.EmpEmail === email);
    console.log("fsgsdg", employee)
    setcurrentEmployee(employee)
  }, [email, employees]);

  useEffect(() => {
    dispatch(setSelectedTabState());
    dispatch(setFilterRequestProjectsState());
    dispatch(setApprovedOpProjectsState([]))
    dispatch(setAssignedOpProjectsState());
    dispatch(setOngoingOpProjectsState());
    dispatch(setCompleteOpProjectsState());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchEmployees());

  }, [dispatch]);

  const handlerefresh = async () => {
    await dispatch(fetchAllProjects());
  }

  const OpProjectRequest = useRef(null);
  const OpProjectAssigned = useRef(null);
  const OpProjectOngoing = useRef(null);
  const OpProjectCompleted = useRef(null);
  const OpProjectApproved = useRef(null);

  const LoggedUser = localStorage.getItem("email");

  const refsMap = useMemo(
    () => ({
      projectRequested: OpProjectRequest,
      projectAssigned: OpProjectAssigned,
      projectOngoing: OpProjectOngoing,
      projectCompleted: OpProjectCompleted,
      projectApproved: OpProjectApproved,
    }),
    []
  );

  // 🔹 Scroll smoothly whenever selectedTabState changes; defer so table section is mounted and ref is set
  useLayoutEffect(() => {
    if (!selectedTabState) return;
    const scrollToTable = () => {
      const node = refsMap[selectedTabState]?.current;
      if (node) {
        node.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    let timeoutId;
    const id = requestAnimationFrame(() => {
      scrollToTable();
      // Fallback: scroll again after layout so table is fully rendered (fixes "Project Ongoing" not redirecting)
      timeoutId = setTimeout(scrollToTable, 100);
    });
    return () => {
      cancelAnimationFrame(id);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [selectedTabState, refsMap]);
  const [ongoingProjectsOP, setOngoingProjectsOP] = useState([]);

  useEffect(() => {
    const filtered = projects.filter(
      (proj) =>
        Array.isArray(proj.Assignedperson) &&
        proj.Assignedperson.some(
          (person) => person.managerstatus === "project ongoing"
        )
    );
    const managerProjects = filtered.filter((proj) =>
      proj.Assignedperson?.some(
        (person) => person.email?.toLowerCase() === LoggedUser.toLowerCase()
      )
    );
    setOngoingProjectsOP(managerProjects);
  }, [projects, LoggedUser]);

  // Use ref to track if this component should update Redux (prevents flickering)
  const shouldUpdateReduxRef = useRef(true);
  
  useEffect(() => {
    // Check if this is the Operations Person's own page (not hidden ProjectManager)
    // The hidden ProjectManager has width: 0 and height: 0, so we can detect it
    const hiddenProjectManager = document.querySelector('[style*="position: absolute"][style*="width: 0"]');
    const isHiddenComponent = hiddenProjectManager && hiddenProjectManager.contains(document.activeElement);
    shouldUpdateReduxRef.current = !isHiddenComponent;
  }, []);

  useEffect(() => {
    const email = localStorage.getItem("email");
    const filteredEmployee = employees.find((emp) => emp.EmpEmail === email);
    if (projectTrackingWorkEntries?.length && filteredEmployee && ongoingProjectsOP?.length) {
      const ongoingProjectIds = ongoingProjectsOP.map(project => project._id);

      const filtered = projectTrackingWorkEntries.filter((entry) => {
        const matchesEmployee = entry.taskownerid === filteredEmployee._id;
        const matchesProject = ongoingProjectIds?.includes(entry.projectid);

        return matchesEmployee && matchesProject;
      });

      const hardwareParts = hardwareProjectTracking.filter((entry) => {
        const matchesProject = ongoingProjectIds?.includes(entry.projectid);
        const matchesEmployee = entry.taskownerid === filteredEmployee._id;
        return matchesProject && matchesEmployee;
      });

      setongoingEntries(filtered);
      setongoingHardwareParts(hardwareParts);
      
      // Only update Redux state if this is the active Operations Person page
      // This prevents flickering when Operations Manager selects an employee
      if (shouldUpdateReduxRef.current) {
        dispatch(setOngoingWorkentries(filtered || []));
        dispatch(setOngoingHardwareParts(hardwareParts || []));
        dispatch(setOngoingProjectsRedux(ongoingProjectsOP || []));
      }
    } else {
      setongoingEntries([]);
      // Only clear Redux state if this is the active Operations Person page
      if (shouldUpdateReduxRef.current) {
        dispatch(setOngoingWorkentries([]));
        dispatch(setOngoingHardwareParts([]));
        dispatch(setOngoingProjectsRedux([]));
      }
    }
  }, [projectTrackingWorkEntries, employees, ongoingProjectsOP, hardwareProjectTracking, dispatch]);

  const [loggedEmp, setLoggedEmp] = useState({})
  useEffect(() => {
    const Email = localStorage.getItem('email')
    const loggedEmp = employees?.find((emp) => emp?.EmpEmail === Email);
    setLoggedEmp(loggedEmp)
  }, [employees])

  const hasNoFeatureConfig = !currentEmployee?.featureAccess || currentEmployee.featureAccess.length === 0;

  const taskInHandAccessLevel = getFeatureAccessLevel(currentEmployee, "TASK IN HAND");
  const isViewOnlyTaskInHand = !hasNoFeatureConfig && taskInHandAccessLevel && String(taskInHandAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const utilizationAccessLevel = getFeatureAccessLevel(currentEmployee, "UTILISATION REPORT");
  const isViewOnlyUtilization = !hasNoFeatureConfig && utilizationAccessLevel && String(utilizationAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const myRequestAccessLevel = getFeatureAccessLevel(currentEmployee, "MY REQUEST");
  const isViewOnlyMyRequests = !hasNoFeatureConfig && myRequestAccessLevel && String(myRequestAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  console.log("MyRequests(Ops) Access Level - TASK IN HAND:", taskInHandAccessLevel, "isViewOnly:", isViewOnlyTaskInHand);
  console.log("MyRequests(Ops) Access Level - UTILISATION REPORT:", utilizationAccessLevel, "isViewOnly:", isViewOnlyUtilization);
  console.log("MyRequests(Ops) Access Level - MY REQUEST:", myRequestAccessLevel, "isViewOnly:", isViewOnlyMyRequests);

  // Check if current employee is a hardware employee
  const isHardwareEmployee = currentEmployee?.servicetype?.toLowerCase() === "hardware";

  return (
    <>
      <div className={` bg-[#f3f8f8] w-full`}>
        <div className=" relative pt-2">
          <div
            style={{
              position: "absolute",
              width: 0,
              height: 0,
              overflow: "hidden",
            }}
          >
            <ProjectManager />
          </div>

          <div className="w-full flex gap-5 min-h-[20rem] justify-center pb-0.1 mt-1">
            {/* For hardware employees, only show MY PROJECTS (not APPROVED HRS) */}
            {isHardwareEmployee && hasViewOrFullAccess(currentEmployee, "MY PROJECTS") && (
              <div className="border-gray-400 w-[33%]">
                <ManagerMyProjects projects={ongoingProjectsOP} />
              </div>
            )}
            {/* For non-hardware employees, show MY PROJECTS and/or APPROVED HRS */}
            {!isHardwareEmployee && (hasViewOrFullAccess(currentEmployee, "MY PROJECTS") || hasViewOrFullAccess(currentEmployee, "APPROVED HRS")) && (
              <div className={`border-gray-400 ${
                (hasViewOrFullAccess(currentEmployee, "MY PROJECTS") && !hasViewOrFullAccess(currentEmployee, "APPROVED HRS")) ? "w-[25%]" :
                  (!hasViewOrFullAccess(currentEmployee, "MY PROJECTS") && hasViewOrFullAccess(currentEmployee, "APPROVED HRS")) ? "w-[25%]" :
                    (hasViewOrFullAccess(currentEmployee, "MY PROJECTS") && hasViewOrFullAccess(currentEmployee, "APPROVED HRS")) ? "w-[50%]" : ""
              } `}>
                <ManagerMyProjects projects={ongoingProjectsOP} />
              </div>
            )}
            {hasViewOrFullAccess(currentEmployee, "PRODUCTIVITY") && (
              <div className={`border-gray-400 ${isHardwareEmployee ? "w-[33%]" : "w-[25%] xl:w-[25%]"}`}>
                <SpeedometerGraph ongoingEntries={ongoingEntries} />
              </div>
            )}
            {/* For hardware employees, show MY REQUEST beside PRODUCTIVITY in first row */}
            {isHardwareEmployee && hasViewOrFullAccess(currentEmployee, "MY REQUEST") && (
              <div className="w-[33%] relative z-10">
                <OpProjects projects={projects} />
              </div>
            )}
            {/* Hide PROJECTS & TIME ENTRIES for hardware employees */}
            {!isHardwareEmployee && hasViewOrFullAccess(currentEmployee, "PROJECTS & TIME ENTRIES") && (
              <div className="border-gray-400 w-[25%] xl:w-[25%]">
                <TimeEntriesGraph ongoingProjectsManager={ongoingProjectsOP} ongoingEntries={ongoingEntries} />
              </div>
            )}
          </div>
          {/* For non-hardware employees, show second row with MY REQUEST, TASK IN HAND, UTILISATION REPORT */}
          {!isHardwareEmployee && (
            <div className="w-full flex gap-1 pt-2 h-[22rem]">
              {hasViewOrFullAccess(currentEmployee, "MY REQUEST") && (
                <div className="w-[40%] relative z-10 shrink-0">
                  <OpProjects projects={projects} />
                </div>
              )}
              {hasViewOrFullAccess(currentEmployee, "TASK IN HAND") && (
                <div className="w-[25%] ">
                  <TaskInHand
                    ongoingHardwareParts={ongoingHardwareParts}
                    ongoingEntries={ongoingEntries}
                    ongoingOpProjectsState={ongoingOpProjectsState}
                    isInteractionDisabled={isViewOnlyTaskInHand}
                    isViewOnly={isViewOnlyTaskInHand} />
                </div>
              )}
              {hasViewOrFullAccess(currentEmployee, "UTILISATION REPORT") && (
                <div className="w-[35%]">
                  <UtilizationReport ongoingProjectsManager={ongoingProjectsOP} ongoingEntries={ongoingEntries} User={"Operations"} isInteractionDisabled={isViewOnlyUtilization} isViewOnly={isViewOnlyUtilization} />
                </div>
              )}
            </div>
          )}
          <div className={isHardwareEmployee ? "pt-0.1" : ""}>
            {selectedTabprojectrequest && (
              <div className="pt-2" ref={OpProjectRequest}>
                <ProjectRequestedOP
                  filterRequestProjects={filterRequestProjectsState}
                  handlerefresh={handlerefresh}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
            )}

            {selectedTabprojectapproved && (
              <div className="pt-4" ref={OpProjectApproved}>
                <ProjectApprovedDash
                  approvedOpProjectsState={approvedOpProjectsState}
                  handlerefresh={handlerefresh}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
            )}
            {selectedTabprojectassign && (
              <div ref={OpProjectAssigned}>
                <ProjectAssignOPdash
                  assignedOpProjects={assignedOpProjectsState}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
            )}

            {selectedTabprojectongoing && (
              <div className="pt-4" ref={OpProjectOngoing}>
                <ProjectOngoingOPDash
                  ongoingOpProjects={ongoingOpProjectsState}
                  handlerefresh={handlerefresh}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
            )}

            {selectedTabprojectcomplete && (
              <div className="pt-2" ref={OpProjectCompleted}>
                <ProjectCompletedOpDash
                  completeOpProjects={completeOpProjectsState}
                  handlerefresh={handlerefresh}
                  isViewOnly={isViewOnlyMyRequests}
                />
              </div>
            )}
          </div>
          {hasViewOrFullAccess(currentEmployee, "MY TRAININGS") && (
            <div className={`overflow-auto ${selectedTabprojectcomplete || selectedTabprojectongoing || selectedTabprojectassign || selectedTabprojectapproved || selectedTabprojectrequest ? "pt-2" : "pt-4"}`}>
              {["L3", "L4"].includes(loggedEmp?.EmpAuthLevel) && (
                <MyTraining projects={projects} />
              )}
            </div>
          )}
        </div>

      </div>

    </>
  );
};

export default MyRequests;
